import React, { useState, useEffect  } from 'react';
import styles from '../styles/3Dhtml.module.css';
import {faDiscord, faGithub, faLinkedin} from "@fortawesome/free-brands-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope } from "@fortawesome/free-solid-svg-icons";
import ItemBox from './ItemBox';
import { useMediaQuery } from 'react-responsive';


function TypingText({ text, delay }){
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setCurrentText(prevText => prevText + text[currentIndex]);
        setCurrentIndex(prevIndex => prevIndex + 1);
      }, delay);
  
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, delay, text]);
  return(
    <h1 className={`${styles.page1head} ${styles.animTypewriter}`}>
        &nbsp;{currentText}
    </h1>
  )
}

function Html(props) {
  const isSmallScreen = useMediaQuery({
    query: '(max-width: 600px) and (max-height: 930px)',
  });
  const [isMouseInside, setIsMouseInside] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (event) => {
    const bioElement = document.getElementById('bio');
    if (bioElement) {
      const parentRect = bioElement.getBoundingClientRect();
      setPosition({
        x: event.clientX - parentRect.left,
        y: event.clientY - parentRect.top
      });
    }
  };

  useEffect(() => {
    // Adding event listener for mousemove
    document.addEventListener('mousemove', handleMouseMove);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []); // Empty dependency array ensures the effect runs only once, on mount

  const handleButtonClick = () => {
    // Navigate to the desired route when the button is clicked
    props.navigate('/projects');
  };

  const handleBoxClick = (event) => {
    props.onStateChange({state: true, type: event.currentTarget.dataset.item});
  }


  return (
    <>
      <TypingText text="Welcome To JS Coding." delay={100} />
      <hr className={styles.bioDivider} />
      <div id="bio" 
        className={styles.bioBox} 
        onMouseEnter={() => setIsMouseInside(true)}
        onMouseLeave={() => setIsMouseInside(false)}>
        <div id="bioBg" 
          className={styles.boxBg} 
          style={{
            position: 'absolute',
            top: isMouseInside ? position.y + 'px' : '50%',
            left: isMouseInside ? position.x + 'px' : '80%',
            transform: isMouseInside ? 'translate(-50%, -50%)' : 'translate(-80%, -50%)',
            transition: isMouseInside ? '' : 'all .2s ease-in-out'
          }}>
        </div>
        <div className={styles.bioText}>
          <h1>JARED SANTORO</h1>
          <div>
          <p>I AM A</p>
          <div className={styles.spinner}>
            <span className={styles.changingText}>
                WEB DEVELOPER<br />
                UI/UX DESIGNER<br />
                SOFTWARE DEVELOPER<br />
                OOP PROGRAMMER<br />
              </span>
          </div>
          </div>
          <button onClick={handleButtonClick} className={styles.bioButton}>See Projects</button>
          <div className={styles.socials}>
            <a href="https://github.com/jazzajing">
                <FontAwesomeIcon icon={faGithub} />
            </a>
            <a href="mailto:jared.santoro@santoro-london.com">
                <FontAwesomeIcon icon={faEnvelope} />
            </a>
            <a href="https://www.linkedin.com/in/jared-santoro-9b57651a2/">
                <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a href="https://discordapp.com/users/696108390589661225">
                <FontAwesomeIcon icon={faDiscord} />
            </a>
          </div>
        </div>
      </div>
      <h1 className={styles.page2head}>
        Skills
      </h1>
      {/* Front End */}
      <h1 className={`${styles.skillshead} ${styles.skills1head}`}>
        Front End
      </h1>
      {isSmallScreen ? (
        <div className={`${styles.skillsBox} ${styles.skillSection1}`}>
          {/* Row 1 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="HTML5" 
              clickHandler={handleBoxClick} 
              dataItem="HTML5" 
            />
            <ItemBox 
              skillName="CSS3" 
              clickHandler={handleBoxClick} 
              dataItem="CSS3" 
            />
          </div>
          {/* Row 2 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="Figma" 
              clickHandler={handleBoxClick} 
              dataItem="Figma" 
            />
            <ItemBox 
              skillName="JavaScript"  
              clickHandler={handleBoxClick} 
              dataItem="JavaScript" 
            />
          </div>
          {/* Row 3 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="ReactJS" 
              clickHandler={handleBoxClick} 
              dataItem="ReactJS" 
            />
            <ItemBox 
              skillName="ThreeJS" 
              clickHandler={handleBoxClick} 
              dataItem="ThreeJS" 
            />
          </div>
        </div>
      ):(
        <div className={`${styles.skillsBox} ${styles.skillSection1}`}>
          {/* Row 1 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="HTML5" 
              tagline="Web Development" 
              clickHandler={handleBoxClick} 
              dataItem="HTML5" 
            />
            <ItemBox 
              skillName="CSS3" 
              tagline="Web Development" 
              clickHandler={handleBoxClick} 
              dataItem="CSS3" 
            />
            <ItemBox 
              skillName="Figma" 
              tagline="Wireframing" 
              clickHandler={handleBoxClick} 
              dataItem="Figma" 
            />
          </div>
          {/* Row 2 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="JavaScript" 
              tagline="Scripting Language" 
              clickHandler={handleBoxClick} 
              dataItem="JavaScript" 
            />
            <ItemBox 
              skillName="ReactJS" 
              tagline="Client-Side Library" 
              clickHandler={handleBoxClick} 
              dataItem="ReactJS" 
            />
            <ItemBox 
              skillName="ThreeJS" 
              tagline="3D Web Graphics" 
              clickHandler={handleBoxClick} 
              dataItem="ThreeJS" 
            />
          </div>
        </div>
      )}
      {/* Back End */}
      <h1 className={`${styles.skillshead} ${styles.skills2head}`}>
        Back End
      </h1>
      {isSmallScreen ? (
        <div className={`${styles.skillsBox} ${styles.skillSection2}`}>
          {/* Row 1 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="PostgreSQL" 
              clickHandler={handleBoxClick} 
              dataItem="Postgres" 
            />
            <ItemBox 
              skillName="Linux" 
              clickHandler={handleBoxClick} 
              dataItem="Linux" 
            />
          </div>
          {/* Row 2 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="AWS" 
              clickHandler={handleBoxClick} 
              dataItem="AWS" 
            />
            <ItemBox 
              skillName="REST APIs" 
              clickHandler={handleBoxClick} 
              dataItem="APIs" 
            />
          </div>
          {/* Row 3 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="GitHub" 
              clickHandler={handleBoxClick} 
              dataItem="GitHub" 
            />
            <ItemBox 
              skillName="Node.js" 
              clickHandler={handleBoxClick} 
              dataItem="NodeJS" 
            />
          </div>
        </div>
      ): (
        <div className={`${styles.skillsBox} ${styles.skillSection2}`}>
          {/* Row 1 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="PostgreSQL" 
              tagline="Database Management" 
              clickHandler={handleBoxClick} 
              dataItem="PostgreSQL" 
            />
            <ItemBox 
              skillName="Linux" 
              tagline="Server OS" 
              clickHandler={handleBoxClick} 
              dataItem="Linux" 
            />
            <ItemBox 
              skillName="AWS" 
              tagline="Cloud Computing" 
              clickHandler={handleBoxClick} 
              dataItem="AWS" 
            />
          </div>
          {/* Row 2 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="REST APIs" 
              tagline="Application Interface" 
              clickHandler={handleBoxClick} 
              dataItem="APIs" 
            />
            <ItemBox 
              skillName="GitHub" 
              tagline="Version Control" 
              clickHandler={handleBoxClick} 
              dataItem="GitHub" 
            />
            <ItemBox 
              skillName="Node.js" 
              tagline="Server Side Scripting" 
              clickHandler={handleBoxClick} 
              dataItem="NodeJS" 
            />
          </div>
        </div>
      )}
      {/* OOP */}
      <h1 className={`${styles.skillshead} ${styles.skills3head}`}>
        OOP
      </h1>
      {isSmallScreen ? (
        <div className={`${styles.skillsBox} ${styles.skillSection3}`}>
          {/* Row 1 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="Python" 
              clickHandler={handleBoxClick} 
              dataItem="Python" 
            />
            <ItemBox 
              skillName="C++" 
              clickHandler={handleBoxClick} 
              dataItem="CPP" 
            />
          </div>
          {/* Row 2 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="Java" 
              clickHandler={handleBoxClick} 
              dataItem="Java" 
            />
            <ItemBox />
          </div>
        </div>
      ):(
        <div className={`${styles.skillsBox} ${styles.skillSection3}`}>
          {/* Row 1 - Hover Boxes */}
          <div className={styles.skillsRow}>
            <ItemBox 
              skillName="Python" 
              tagline="AI Modelling/Web Scraping" 
              clickHandler={handleBoxClick} 
              dataItem="Python" 
            />
            <ItemBox 
              skillName="C++" 
              tagline="3D Graphics" 
              clickHandler={handleBoxClick} 
              dataItem="CPP" 
            />
            <ItemBox 
              skillName="Java" 
              tagline="P2P Communications" 
              clickHandler={handleBoxClick} 
              dataItem="Java" 
            />
          </div>
        </div>
      )}
    </>
  )
}

export { Html }